import React from 'react'
import HTML from '../assets/html.png'
import CSS from '../assets/css.png'
import JAVASCRIPT from '../assets/javascript.png'
import GITHUB from '../assets/github.png'
import TAILWIND from '../assets/tailwind.png'
import REACTJS from '../assets/react.png'
import MONGO from '../assets/mongo.png'
import FIREBASE from '../assets/firebase.png'
import NODEJS from '../assets/node.png'

function Skills() {
    return (
        <div name='skills' className='bg-[#0a192f] w-full h-screen text-gray-300'>
            {/* Container */}
            <div className='max-w-[1000px] mx-auto p-5 flex flex-col w-full h-full justify-center items-center'>
                <div className='text-center my-10'>
                    <p className='text-4xl font-bold inline border-b-4 border-pink-600'>My Skills</p>
                </div>
                {/* Technology-area */}
                <div className='w-full grid grid-cols-2 sm:grid-cols-3 gap-5 text-center py-5'>
                    <div className='shadow-md shadow-[#3f4854] hover:scale-110 duration-300 p-2 hover:shadow-none'>
                        <img src={HTML} alt='HMTL' className='w-[50px] mx-auto' />
                        <p className='mt-2'>HTML</p>
                    </div>
                    <div className='shadow-md shadow-[#3f4854] hover:scale-110 duration-300 p-2 hover:shadow-none'>
                        <img src={CSS} alt='CSS' className='w-[50px] mx-auto' />
                        <p className='mt-2'>CSS</p>
                    </div>
                    <div className='shadow-md shadow-[#3f4854] hover:scale-110 duration-300 p-2 hover:shadow-none'>
                        <img src={JAVASCRIPT} alt='JAVASCRIPT' className='w-[50px] mx-auto' />
                        <p className='mt-2'>JAVASCRIPT</p>
                    </div>
                    <div className='shadow-md shadow-[#3f4854] hover:scale-110 duration-300 p-2 hover:shadow-none'>
                        <img src={GITHUB} alt='GITHUB' className='w-[50px] mx-auto' />
                        <p className='mt-2'>GITHUB</p>
                    </div>
                    <div className='shadow-md shadow-[#3f4854] hover:scale-110 duration-300 p-2 hover:shadow-none'>
                        <img src={REACTJS} alt='REACTJS' className='w-[50px] mx-auto' />
                        <p className='mt-2'>REACTJS</p>
                    </div>
                    <div className='shadow-md shadow-[#3f4854] hover:scale-110 duration-300 p-2 hover:shadow-none'>
                        <img src={NODEJS} alt='NODEJS' className='w-[50px] mx-auto' />
                        <p className='mt-2'>NODEJS</p>
                    </div>
                    <div className='shadow-md shadow-[#3f4854] hover:scale-110 duration-300 p-2 hover:shadow-none'>
                        <img src={TAILWIND} alt='TAILWIND' className='w-[50px] mx-auto' />
                        <p className='mt-2'>TAILWIND</p>
                    </div>
                    <div className='shadow-md shadow-[#3f4854] hover:scale-110 duration-300 p-2 hover:shadow-none'>
                        <img src={MONGO} alt='MONGODB' className='w-[50px] mx-auto' />
                        <p className='mt-2'>MONGODB</p>
                    </div>
                    <div className='shadow-md shadow-[#3f4854] hover:scale-110 duration-300 p-2 hover:shadow-none'>
                        <img src={FIREBASE} alt='FIREBASE' className='w-[50px] mx-auto' />
                        <p className='mt-2'>FIREBASE</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Skills